<template>
  <div class="h">
    <div
      v-for="conversation in conversations"
      v-if="conversation.last_message || isOrderDetail"
      :key="conversation.id"
      :class="['item', { active: activeConversation.id === conversation.id }]"
      @click="select(conversation)"
    >
      <div>
        <h2>{{ conversation.users[0].fullname }}</h2>

        <p>
          {{ lastMessage(conversation).body }}
        </p>
        <span class="ago">
          {{ lastMessageDate(conversation) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    conversations: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeConversation: {}
    }
  },
  computed: {
    isOrderDetail () {
      return window.location.pathname.startsWith('/orders/')
    }
  },
  mounted() {
    if (this.conversations.length > 0) {
      this.select(this.conversations[0])
    }

    setInterval(() => {
      this.$forceUpdate()
    }, 1000 * 60)
  },
  methods: {
    select(conversation) {
      if (this.activeConversation.id === conversation.id) return

      this.activeConversation = conversation
      this.$emit('pick', conversation)
    },
    lastMessage(conversation) {
      return conversation && conversation.last_message && conversation.last_message.type === 'text'
        ? conversation.last_message
        : {}
    },
    lastMessageDate(conversation) {
      return moment(this.lastMessage(conversation).created_at).fromNow()
    }
  }
}
</script>
